import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./slider.css";
import { responseFile } from "../../type/responseFile";

const Slider: React.FC<{
  images: string[] | responseFile[];
  text: boolean;
}> = ({ images, text }) => {
  return (
    <div className="slider-container">
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        navigation
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        speed={800}
        pagination={true}
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
      >
        {images.map((image: any, index) => (
          <SwiperSlide key={index} style={{ zIndex: "10" }}>
            <img
              src={image?.thumbnail_address || image}
              alt="picture1"
              className="mt-10 md:mt-3 w-full object-contain h-[380px]"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
